import type { IAuthOptions } from '../types/IAuthOptions';
import type { IAuthSession } from '../types/IAuthSession';
import type { IAuthUser } from '../types/IAuthUser';

/** Сирий користувач відповіді сервера: ім'я приходить як displayName або name. */
interface IWireUser { id?: string; displayName?: string | null; name?: string | null; email?: string | null }

/** Користувач відповіді /auth/* у сталій формі (ім'я — displayName, інакше name, інакше e-mail). Чиста функція. */
export function toAuthUser(raw: unknown): IAuthUser {
  const u = (raw ?? {}) as IWireUser;
  const email = u.email ?? null;
  return { id: u.id ?? '', displayName: u.displayName || u.name || email || '', email };
}

/** Тіло {user} або сам користувач. Чиста функція. */
export function userOf(body: unknown): IAuthUser {
  const b = (body ?? {}) as { user?: unknown };
  return toAuthUser(b.user ?? body);
}

/** Сесія GET /auth/me: користувач і ознака спостерігача (лише true вмикає режим «лише перегляд»). Чиста функція. */
export function toAuthSession(body: unknown): IAuthSession {
  return { user: userOf(body), observer: (body as { observer?: unknown } | null)?.observer === true };
}

/** Параметри входу з типовими значеннями для полів, яких сервер не надіслав (усе вимкнено, режим 'prod'). Чиста функція. */
export function toAuthOptions(body: unknown): IAuthOptions {
  const b = (body ?? {}) as Partial<IAuthOptions>;
  const p: Partial<IAuthOptions['providers']> = b.providers ?? {};
  return {
    providers: { google: !!p.google, microsoft: !!p.microsoft, password: !!p.password, idgovua: !!p.idgovua },
    selfRegistration: !!b.selfRegistration,
    observer: !!b.observer,
    mode: b.mode === 'dev' ? 'dev' : 'prod',
    demoEmail: b.demoEmail || null,
  };
}
